<template>
  <div class="rewardList pda-default d-flex justify-content-between">
    <div class="pdr-32 pdt-4">
      <img
        src="images/reward/database-plus.png"
        alt=""
        class="max-w-22"
        v-if="pointList && pointList.type && pointList.type.value == 'EARN'"
      />
      <img
        src="images/reward/database-minus.png"
        alt=""
        class="max-w-22"
        v-if="pointList && pointList.type && pointList.type.value == 'LOSE'"
      />
    </div>
    <div class="rewardCardContent mgr-auto">
      <div
        class="t-color-title t-body1 l-spacing48"
        v-if="pointList.explain && pointList.explain.translate"
      >
        {{ pointTitle(pointList.explain.translate) }}
      </div>

      <!-- 각 포인트 별 설명 -->
      <div
        class="t-body3 mgb-4 over-text"
        v-if="pointList.detailExplain"
      >
        {{ pointList.detailExplain }}
      </div>

      <div class="t-color-gray2 t-body3">
        {{ $moment(pointList.assignTime).format("L") }}
      </div>
    </div>
    <div
      v-if="pointList && pointList.type && pointList.type.value == 'EARN'"
      class="t-color-title t-subtitle4 t-nowrap"
    >
      +{{ pointList.point }}
    </div>
    <div
      v-if="pointList && pointList.type && pointList.type.value == 'LOSE'"
      class="t-color-title t-subtitle4 t-nowrap"
    >
      -{{ pointList.point }}
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["pointList", "myStatus"],
  data() {
    return {
      learnProgressRate: {},
    };
  },
  methods: {
    pointTitle(translate) {
      switch (translate) {
        case "ui.membership.point.firstLogin":
          return this.$t("S20101")
        case "ui.membership.point.login":
            return this.$t("S20102")
        case "ui.membership.point.enterDegree":
            return this.$t("S20103")
        case "ui.membership.point.completeDegree":
            return this.$t("S20104")
        case "ui.membership.point.completeExam":
            return this.$t("S20105")
        case "ui.membership.point.allSolveExam":
            return this.$t("S20106")
        case "ui.membership.point.completeSurvey":
            return this.$t("S20107")
        case "ui.membership.point.allSolveSurvey":
            return this.$t("S20108")
        case "ui.membership.point.registerArticle":
            return this.$t("S20109")
        case "ui.membership.point.registerComment":
            return this.$t("S20110")
        case "ui.membership.point.exitDegree":
            return this.$t("S20111")
        case "ui.membership.point.incompleteDegree":
            return this.$t("S20112")
        case "ui.membership.point.removeArticle":
            return this.$t("S20113")
        case "ui.membership.point.removeComment":
            return this.$t("S20114")
        case "ui.membership.point.registerLikes":
            return this.$t("S20115")
        case "ui.membership.point.removeLikes":
            return this.$t("S20116")
        case "ui.membership.point.assignByAdmin":
            return this.$t("S20117")
        case "ui.membership.point.unassignByAdmin":
            return this.$t("S20118")
        case "ui.membership.point.newBadge":
            return this.$t("S20119")
        case "ui.membership.point.prizePurchase":
            return this.$t("S20128")
        default:
          return this.$t(translate)
      }
    }
  },
};
</script>

<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.rewardTitle {
  font-size: 16px;
}
.crown226 {
  max-width: 226px;
}
.shadow135 {
  max-width: 135px;
  height: 30px;
}
.t-size70 {
  font-size: 70px;
  font-weight: 600;
  line-height: 0.29;
}
.link-green {
  border-radius: 18px;
  border: solid 1px #70cfc8;
  background-color: rgba(112, 207, 200, 0.1);
}
.link-red {
  border-radius: 18px;
  border: solid 1px #ff847b;
  background-color: rgba(241, 109, 112, 0.1);
}
.border-bottom {
  border-bottom: 1px solid #f1f1f1;
}
.graphWrapper {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
}
.l-spacing12 {
  letter-spacing: -0.12px !important;
}
.rewardCardContent {
  width: calc(100% - 52px);
}
.over-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #818181 !important;
  width: 200px;
}
</style>